<a [href]="linkUrl" mat-flat-button>{{ label }}</a>
